class WatchManuals extends HTMLElement {
  constructor() {
    super()

    this.input = this.querySelector('.js-manuals-search-details-input')
    this.items = this.querySelectorAll('.js-manuals-item')

    this.checkNoResult = this.checkNoResult.bind(this)
  }

  connectedCallback() {
    this.onInputHandler = this.onInputHandler.bind(this)
    this.input.addEventListener('input', this.onInputHandler)
  }

  disconnectedCallback() {
    this.input.removeEventListener('input', this.onInputHandler)
  }

  onInputHandler(e) {
    const term = String(e.target.value).trim().toLowerCase()

    let manual_title = '',
      manual_features = '',
      legacy_skus = '',
      product_titles = '',
      product_skus = ''
    this.items.forEach(item => {
      manual_title = item.dataset.manualTitle
      manual_features = item.dataset.manualFeatures
      legacy_skus = item.dataset.legacySkus
      product_titles = item.dataset.productTitles
      product_skus = item.dataset.productSkus

      if (
        manual_title.includes(term) ||
        manual_features.includes(term) ||
        legacy_skus.includes(term) ||
        product_titles.includes(term) ||
        product_skus.includes(term)
      ) {
        item.classList.remove('hidden')
      } else {
        item.classList.add('hidden')
      }
    })

    this.checkNoResult()
  }

  checkNoResult() {
    const results = [...this.items].filter(item => !item.classList.contains('hidden'))
    this.classList[results.length? 'remove': 'add']('watch-manuals__no-result')
  }
}

customElements.define('watch-manuals', WatchManuals)
